<template>
  <div></div>
</template>

<script>
export default {
  name: 'logout',
  created () {
    console.log('created:logout')
    var self = this
    this.$store.dispatch('User/logout').then(function () {
      self.$router.push('/login')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/04-pages/Logout.vue